import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAssessmentContentsData,
  getCourseraContents,
} from "../../slices/courseraSlice";
import { LoadingOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Avatar } from "antd";
import {
  attemptAssessment,
  getAttemptAssessmentData,
} from "../../services/awsServices";
import { ClockIcon, LocationIcon } from "../../utils/icons";
import cognitiveImg from "../../assets/assessment/cognitive_Assessment.jpg";
import CorporateImg from "../../assets/assessment/Corporate_Communication_Assessment.jpg";
import DigitalImg from "../../assets/assessment/Digital_Readiness_Assessment.jpg";
import EmotionalImg from "../../assets/assessment/Emotional_Intelligence_Assessment.jpg";
import LeadershipImg from "../../assets/assessment/Leadership_Assessment.jpg";
import LearningImg from "../../assets/assessment/Learning_Agility_Assessment.jpg";
import PersonalityImg from "../../assets/assessment/Personality_Assessment.jpg";
import AssessmentModal from "../AssessmentModal";
import LoadingCom from "../LoadingCom";

function RecommendedAssesment() {
  const [loading, setLoading] = useState(false);
  const assessmentData = useSelector((state) => state.coursera.assessmentData);

  const [resData, setResData] = useState([]);
  const dispatch = useDispatch();
  const [AttemptedId, setAttemptedId] = useState([]);
  const [AttemptedData, setAttemptedData] = useState();
  const email = localStorage.getItem("username");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleBoxClick = (course) => {
    setSelectedCourse(course); // Update state with data of the clicked box
    setIsModalOpen(true); // Open the modal
  };

  const getAttemptedResults = async () => {
    try {
      const ids = [];
      const res = await getAttemptAssessmentData(email);
      console.log(res, "ressssssss");
      setAttemptedData(res?.data?.data?.testInstances);
      res?.data?.data?.testInstances?.map((items) => {
        ids.push(items?.assessmentId);
      });
      //   const res = await attemptAssessment(data?.id);

      //   const schedules = res2?.data?.data?.schedules;

      //   console.log(res2, "fetchattemp")

      setAttemptedId(ids);
    } catch (error) {
      console.log(error, "erorr");
    }
  };

  //   const attemptAssessmentFun = async () => {
  //     setLoading(true); // Set loading to true when fetching data
  //     try {
  //       if (res) {
  //         const schedules = res?.data?.data?.schedules;
  //         const assessmentResults = await Promise.all(
  //           schedules?.map((schedule) => {
  //             return attemptAssessmentResult(schedule.accessKey, email);
  //           })
  //         );
  //         // Combine schedules and assessment results into an object
  //         const assessmentData = {
  //           schedules: schedules,
  //           assessmentResults: assessmentResults,
  //         };
  //         // Set the combined data object in the state
  //         setAssessment(assessmentData);
  //       }
  //     } catch (error) {
  //       console.log("Error fetching assessment:", error);
  //     } finally {
  //       setLoading(false); // Set loading to false whether fetching is successful or not
  //     }
  //   };

  useEffect(() => {
    dispatch(getAssessmentContentsData());
    // attemptAssessmentFun();
    getAttemptedResults();
  }, []);

  console.log({ assessmentData });
  return (
    <div className="rounded-2xl p-5 shadow-shadowOne bg-pureWhite overflow-auto h-full">
      <h2 className="font-semibold text-lg ">Recommended Assessment</h2>

      <div className="space-y-4 my-2">
        {assessmentData?.length ? (
          assessmentData?.slice(0, 4)?.map((items, i) => {
            return (
              <div
                onClick={() => handleBoxClick(items)}
                key={i}
                className="bg-lightGrey p-4 rounded-3xl"
              >
                <div className="flex justify-between my-2">
                  <p className="text-sm text-gray-600">
                    {/* Level: {items?.difficultyLevel} */}
                  </p>
                </div>
                <div className="flex items-center space-x-4 ">
                  <div className="rounded-full bg-gray-400 ">
                    <Avatar
                      src={
                        items?.name === "Cognitive Assessment"
                          ? cognitiveImg
                          : items?.name ===
                            "Corporate Communication Skills Assessment"
                          ? CorporateImg
                          : items?.name === "Digital Readiness Assessment"
                          ? DigitalImg
                          : items?.name === "Emotional Intelligence Assessment"
                          ? EmotionalImg
                          : items?.name === "Leadership Assessment"
                          ? LeadershipImg
                          : items?.name === "Learning Agility Assessment"
                          ? LearningImg
                          : items?.name === "Personality Assessment"
                          ? PersonalityImg
                          : "https://www.unityoga.org/uploads/2/5/7/4/25747040/research-assessment-evaluation-fb_orig.jpg"
                      }
                      size={"large"}
                    />
                  </div>
                  <div className="flex-grow  items-center">
                    <h3 className="text-lg font-medium">{items?.name}</h3>
                    <p className="text-sm text-gray-600 flex items-center gap-1">
                      {/* {items?.partners[0]?.name} */}
                      <span>
                        <ClockIcon />
                      </span>
                      {/* <span>{course?.duration}</span> */}
                      <span>{items?.createdAt}</span>
                    </p>
                    <p className="flex items-center gap-1 text-[10px] ml-1 mt-1 text-gray-400">
                      <LocationIcon />

                      {/* <span>{course?.location}</span> */}
                      {items?.assessmentType}
                    </p>
                  </div>
                  <div className="text-center ">
                    <button className="bg-buttonGradient w-[100px] mb-3 text-white rounded-3xl px-4 py-2">
                      <Link>Attempt</Link>
                    </button>
                    <p className="text-xs text-gray-500">
                      {" "}
                      Max Marks {items?.maxMarks}
                    </p>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <LoadingCom />
        )}
      </div>
      <AssessmentModal
        data={selectedCourse}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
      />
      {/* <div className="text-center my-10">
        {courseData?.paging?.total <= resData.length ? (
          <h1 className="bg-signupTextBg inline-block text-transparent bg-clip-text font-semibold text-lg">
            No additional data to display.
          </h1>
        ) : (
          <>
            {courseData?.elements?.length && (
              <button
                className={`m-auto my-10 flex items-center justify-center gap-x-4 py-2 px-6 bg-gradient-to-l from-darkerOrange via-darkOrange to-lightOrange hover:bg-gradient-to-bl text-white drop-shadow-md rounded-full`}
                onClick={() => {
                  // setLimit((prev) => prev + 10);
                  setStart((prev) => prev + 10);
                }}
              >
                Load More
                {loading && <LoadingOutlined />}
              </button>
            )}
          </>
        )}
      </div> */}
    </div>
  );
}

export default RecommendedAssesment;
